import React from "react"
import "../Css_files/career_c1.css"

const OnlineLearningHero = () => {
  return (
    <section className="career-hero" id="learning-home">
      <div className="career-hero-background">
        <div className="career-hero-overlay"></div>
      </div>

      <div className="career-hero-container">
        <div className="career-hero-content">
          <h1 className="career-hero-title">
            Learn New Skills Anytime with <span className="career-hero-highlight">Profenaa Online</span>
          </h1>
          <p className="career-hero-subtitle">
            Access interactive courses, hands-on projects, and expert guidance from industry professionals. 
            Master technology, design, business, and more — all from the comfort of your home.
          </p>
          <div className="career-hero-buttons">
            <button className="career-hero-btn career-hero-btn-primary">Browse Courses</button>
            <button className="career-hero-btn career-hero-btn-secondary">Start Free Demo</button>
          </div>
        </div>

        <div className="career-hero-stats">
          <div className="career-hero-stat-card">
            <div className="career-hero-stat-number">200K+</div>
            <div className="career-hero-stat-label">Learners</div>
          </div>
          <div className="career-hero-stat-card">
            <div className="career-hero-stat-number">1,200+</div>
            <div className="career-hero-stat-label">Expert Instructors</div>
          </div>
          <div className="career-hero-stat-card">
            <div className="career-hero-stat-number">50+</div>
            <div className="career-hero-stat-label">Courses</div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default OnlineLearningHero;
